export const ChangePrinterResponse = {
    CONNECTION_FAILED_PRINTER_OFF: "connectionFailedPrinterOff",
    CONNECTION_FAILED_UNPAIRED_DEVICE: "connectionFailedUnPairedDevice",
    CONNECTION_FAILED: "connectionFailed",
    UNKNOWN_ERROR: "unknown error"
};


// WEBPACK FOOTER //
// ./src/components/scanPrinter/utils/ChangePrinterResponse.js